import { render, staticRenderFns } from "./WidgetTareas.vue?vue&type=template&id=1165f8ef&scoped=true&"
import script from "./WidgetTareas.vue?vue&type=script&lang=js&"
export * from "./WidgetTareas.vue?vue&type=script&lang=js&"
import style0 from "./WidgetTareas.vue?vue&type=style&index=0&id=1165f8ef&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1165f8ef",
  null
  
)

export default component.exports